<template>
  <div class="title mb-3">
    <div class="row align-items-center row-gap-2">
      <div class="col-md-8">
        <h5 class="mb-1">Kurikulum Course</h5>
        <p class="text-muted fs-14 mb-0">
          Tambah lesson, quiz (opsional), dan exam (opsional) untuk course kamu.
        </p>
      </div>
    </div>
  </div>

  <div class="accordions-items-seperate" id="curriculumAccordion">
    <!-- LESSON -->
    <div class="accordion-item">
      <h2 class="accordion-header" id="headingLesson">
        <a
          href="javascript:void(0);"
          class="accordion-button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseLesson"
          aria-expanded="true"
          aria-controls="collapseLesson"
        >
          <span class="d-flex align-items-center mb-0 flex-wrap gap-2">
            <i class="isax isax-teacher me-1"></i>
            Lesson
            <span class="badge bg-light text-dark border ms-1">
              {{ CourseDataStore.addCourseContent.length }}
            </span>
          </span>
        </a>
      </h2>

      <div
        id="collapseLesson"
        class="accordion-collapse collapse show"
        aria-labelledby="headingLesson"
      >
        <div class="accordion-body">
          <div
            v-if="!CourseDataStore.addCourseContent.length"
            class="border rounded-2 p-4 mb-3 text-center"
          >
            <i
              class="isax isax-video-play text-muted d-block mb-3"
              style="font-size: 2.5rem"
            ></i>
            <h6 class="text-muted mb-1">Belum ada lesson</h6>
            <p class="text-muted fs-14 mb-0">
              Lesson adalah materi utama course kamu. Tambah minimal 1 lesson
              biar siswa punya konten untuk dipelajari.
            </p>
          </div>

          <div
            v-for="(item, index) in CourseDataStore.addCourseContent"
            :key="'lesson-' + index"
            class="d-flex align-items-center justify-content-between bg-white p-2 border rounded-3 mb-3"
          >
            <div class="d-flex align-items-center min-w-0">
              <span class="flex-shrink-0">
                <i class="isax isax-play-circle5 text-success fs-24 me-1"></i>
              </span>
              <div class="min-w-0">
                <p class="fw-medium text-gray-5 mb-0 text-truncate">
                  {{ item.title || `Lesson ${index + 1}` }}
                </p>
                <small v-if="item.type" class="text-muted">{{ item.type }}</small>
              </div>
            </div>
            <div class="d-flex align-items-center flex-shrink-0">
              <a
                href="javascript:void(0);"
                class="edit-btn1"
                title="Edit lesson"
                @click="CourseDataStore.EditContent(index)"
              >
                <i class="isax isax-edit-25 fs-16"></i>
              </a>
              <a
                href="javascript:void(0);"
                class="delete-btn1"
                title="Hapus lesson"
                @click="deleteLesson(index)"
              >
                <i class="isax isax-trash fs-16"></i>
              </a>
            </div>
          </div>

          <a
            href="javascript:void(0);"
            class="btn add-edit-btn d-inline-flex align-items-center"
            @click="CourseDataStore.NewContent()"
          >
            <i class="isax isax-add-circle5 me-2"></i>
            Add Lesson
          </a>
        </div>
      </div>
    </div>

    <!-- QUIZ -->
    <div class="accordion-item">
      <h2 class="accordion-header" id="headingQuiz">
        <a
          href="javascript:void(0);"
          class="accordion-button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseQuiz"
          aria-expanded="true"
          aria-controls="collapseQuiz"
        >
          <span class="d-flex align-items-center mb-0 flex-wrap gap-2">
            <i class="isax isax-message-question me-1"></i>
            Quiz
            <span class="badge bg-light text-dark border ms-1">
              {{ CourseDataStore.addCourseQuiz.length }}
            </span>
            <small class="text-muted fw-normal">Opsional</small>
          </span>
        </a>
      </h2>

      <div
        id="collapseQuiz"
        class="accordion-collapse collapse show"
        aria-labelledby="headingQuiz"
      >
        <div class="accordion-body">
          <div
            v-if="!CourseDataStore.addCourseQuiz.length"
            class="border rounded-2 p-4 mb-3 text-center"
          >
            <i
              class="isax isax-message-question5 text-muted d-block mb-3"
              style="font-size: 2.5rem"
            ></i>
            <h6 class="text-muted mb-1">Belum ada quiz</h6>
            <p class="text-muted fs-14 mb-0">
              Quiz muncul di tengah video buat cek pemahaman siswa. Kamu bisa
              lewati dulu kalau belum perlu.
            </p>
          </div>

          <div
            v-for="(item, index) in CourseDataStore.addCourseQuiz"
            :key="'quiz-' + index"
            class="d-flex align-items-center justify-content-between bg-white p-2 border rounded-3 mb-3"
          >
            <div class="d-flex align-items-center min-w-0">
              <span class="flex-shrink-0">
                <i class="isax isax-message-question5 text-warning fs-24 me-1"></i>
              </span>
              <div class="min-w-0">
                <p class="fw-medium text-gray-5 mb-0 text-truncate">
                  Quiz {{ index + 1 }}
                </p>
                <small class="text-muted">
                  Timestamp: {{ item.popup_time || "—" }}
                </small>
              </div>
            </div>
            <div class="d-flex align-items-center flex-shrink-0">
              <a
                href="javascript:void(0);"
                class="edit-btn1"
                title="Edit quiz"
                @click="CourseDataStore.EditQuizDialog(index)"
              >
                <i class="isax isax-edit-25 fs-16"></i>
              </a>
              <a
                href="javascript:void(0);"
                class="delete-btn1"
                title="Hapus quiz"
                @click="deleteQuiz(index)"
              >
                <i class="isax isax-trash fs-16"></i>
              </a>
            </div>
          </div>

          <a
            href="javascript:void(0);"
            class="btn add-edit-btn d-inline-flex align-items-center"
            @click="CourseDataStore.NewQuizDialog()"
          >
            <i class="isax isax-add-circle5 me-2"></i>
            Add Quiz
          </a>
        </div>
      </div>
    </div>

    <!-- EXAM -->
    <div class="accordion-item">
      <h2 class="accordion-header" id="headingExam">
        <a
          href="javascript:void(0);"
          class="accordion-button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseExam"
          aria-expanded="true"
          aria-controls="collapseExam"
        >
          <span class="d-flex align-items-center mb-0 flex-wrap gap-2">
            <i class="isax isax-clipboard-text me-1"></i>
            Exam
            <span class="badge bg-light text-dark border ms-1">
              {{ hasExam ? 1 : 0 }}
            </span>
            <small class="text-muted fw-normal">Opsional · max 1</small>
          </span>
        </a>
      </h2>

      <div
        id="collapseExam"
        class="accordion-collapse collapse show"
        aria-labelledby="headingExam"
      >
        <div class="accordion-body">
          <div
            v-if="!hasExam"
            class="border rounded-2 p-4 mb-3 text-center"
          >
            <i
              class="isax isax-clipboard-text text-muted d-block mb-3"
              style="font-size: 2.5rem"
            ></i>
            <h6 class="text-muted mb-1">Belum ada exam</h6>
            <p class="text-muted fs-14 mb-3">
              Exam dipakai di akhir course. Satu course cukup satu exam — kamu
              bisa tambah nanti kalau belum siap.
            </p>
            <a
              href="javascript:void(0);"
              class="btn add-edit-btn d-inline-flex align-items-center"
              data-bs-toggle="modal"
              data-bs-target="#add-exam"
            >
              <i class="isax isax-add-circle5 me-2"></i>
              Add Exam
            </a>
          </div>

          <div
            v-else
            class="d-flex align-items-center justify-content-between bg-white p-2 border rounded-3 mb-0"
          >
            <div class="d-flex align-items-center min-w-0">
              <span class="flex-shrink-0">
                <i class="isax isax-clipboard-text text-primary fs-24 me-2"></i>
              </span>
              <div class="min-w-0">
                <p class="fw-medium text-gray-5 mb-0">Exam</p>
                <small class="text-muted">
                  {{ CourseDataStore.ExamDraft.examType }}
                  ·
                  {{ examQuestionDisplayCount }} soal
                  ·
                  {{ CourseDataStore.ExamDraft.time_limit_minutes || "—" }} menit
                </small>
              </div>
            </div>
            <div class="d-flex align-items-center flex-shrink-0">
              <a
                v-if="isEditMode && existingExamID"
                href="javascript:void(0);"
                class="edit-btn1 me-2 text-primary"
                title="Download soal exam sebelumnya (.xlsx)"
                @click="downloadExistingExamExcel"
              >
                <i class="isax isax-document-download fs-16"></i>
              </a>
              <a
                href="javascript:void(0);"
                class="edit-btn1"
                title="Edit exam"
                data-bs-toggle="modal"
                data-bs-target="#add-exam"
              >
                <i class="isax isax-edit-25 fs-16"></i>
              </a>
              <a
                href="javascript:void(0);"
                class="delete-btn1"
                title="Hapus exam"
                @click="deleteExam"
              >
                <i class="isax isax-trash fs-16"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { useCourseDataStore } from "@/stores/course/course-data-store";

export default {
  setup() {
    const CourseDataStore = useCourseDataStore();
    return {
      CourseDataStore,
    };
  },
  computed: {
    hasExam() {
      const s = this.CourseDataStore;
      if ((s.examQuestionsParsed || []).length > 0) return true;
      if (s.ExamDraft?.courseID) return true;
      return !!s.examConfigured;
    },
    isEditMode() {
      return !!(
        this.$route.params?.courseID ||
        this.$route.params?.id ||
        this.$route.query?.courseID ||
        this.$route.query?.id ||
        this.$route.name === "CourseEdit" ||
        (this.$route.path && this.$route.path.includes("/edit"))
      );
    },
    existingExamID() {
      return (
        this.CourseDataStore.ExamDraft?.examID ||
        this.CourseDataStore.courseFetchStore?.basicCourseDetail?.exam?.examID ||
        null
      );
    },
    examQuestionDisplayCount() {
      const parsedCount = (this.CourseDataStore.examQuestionsParsed || []).length;
      if (parsedCount > 0) return parsedCount;
      return (
        this.CourseDataStore.existingExamQuestionCount ||
        this.CourseDataStore.ExamDraft?.question_count ||
        0
      );
    },
  },
  methods: {
    deleteLesson(index) {
      Swal.fire({
        title: "Yakin hapus lesson ini?",
        text: "Kamu tidak bisa mengembalikannya.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Hapus",
        cancelButtonText: "Batal",
      }).then((result) => {
        if (result.isConfirmed) {
          this.CourseDataStore.removeContentItem(index);
          Swal.fire("Terhapus!", "Lesson kamu sudah dihapus.", "success");
        }
      });
    },
    deleteQuiz(index) {
      Swal.fire({
        title: "Yakin hapus quiz ini?",
        text: "Kamu tidak bisa mengembalikannya.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Hapus",
        cancelButtonText: "Batal",
      }).then((result) => {
        if (result.isConfirmed) {
          this.CourseDataStore.removeQuizItem(index);
          Swal.fire("Terhapus!", "Quiz kamu sudah dihapus.", "success");
        }
      });
    },
    deleteExam() {
      Swal.fire({
        title: "Yakin hapus exam ini?",
        text: "Kamu tidak bisa mengembalikannya.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Hapus",
        cancelButtonText: "Batal",
      }).then((result) => {
        if (result.isConfirmed) {
          this.CourseDataStore.clearExamDraft();
          Swal.fire("Terhapus!", "Exam kamu sudah dihapus.", "success");
        }
      });
    },
    downloadExistingExamExcel() {
      this.CourseDataStore.downloadExistingExamExcel();
    },
  },
};
</script>
